"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _componentsBase = require("@telus-uds/components-base");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _utils = require("../utils");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const [selectProps, selectedSystemPropTypes] = (0, _componentsBase.selectSystemProps)([_utils.htmlAttrs]);
const StyledSpan = /*#__PURE__*/_styledComponents.default.span.withConfig({
  displayName: "Span__StyledSpan",
  componentId: "components-web__sc-o7sihn-0"
})(["", "};"], _ref => {
  let {
    flex
  } = _ref;
  return flex ? 'display: inline-flex' : '';
});

/**
 * Text as an HTML ```<span>``` element.
 *
 * Span may be used in cases where an inline span or direct access to HTML attributes is required.
 * In most cases, `Typography` should be used for text, or Paragraph for body text.
 */
const Span = /*#__PURE__*/_react.default.forwardRef((_ref2, ref) => {
  let {
    children,
    variant,
    tokens,
    testID,
    flex,
    ...rest
  } = _ref2;
  const style = (0, _utils.useTypographyTheme)(variant, tokens);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledSpan, {
    "data-testid": testID,
    flex: flex,
    style: style,
    ref: ref,
    ...selectProps(rest),
    children: children
  });
});
Span.displayName = 'Span';
Span.propTypes = {
  ...selectedSystemPropTypes,
  children: _propTypes.default.node.isRequired,
  /**
   * Adds `data-testid` attribute for testing
   */
  testID: _propTypes.default.string,
  /**
   * Sets display to inline-flex so that children are laid out using the flex model.
   * Use this if the span contains children that expect to be inside a flex container.
   */
  flex: _propTypes.default.bool,
  /**
   * Span takes the same tokens overrides as Typography
   */
  tokens: (0, _componentsBase.getTokensPropType)('Typography'),
  /**
   * Span can take any of Typography's theme variants
   */
  variant: _propTypes.default.exact({
    bold: _propTypes.default.bool,
    colour: _propTypes.default.oneOf(['secondary', 'tertiary']),
    compact: _propTypes.default.bool,
    inverse: _propTypes.default.bool,
    size: _propTypes.default.oneOf(['micro', 'small', 'large', 'eyebrow', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'display1', 'display2']),
    weight: _propTypes.default.oneOf(['semibold', 'bold'])
  })
};
var _default = exports.default = Span;